$(function () {

    //header burger
    let $header = $('.js-header'),
        $headerMobile = $('.js-header-mobile'),
        $burger = $header.find('.js-burger')
    
    $burger.on('click', function () {
        $(this).toggleClass('is-active')
        $headerMobile.toggleClass('is-active')
    })
    
    
    //lang dropdown
    let $langWrap = $('.js-header-lang'),
        $langDropdown = $langWrap.find('.js-header-lang__dropdown'),
        $langItem = $langWrap.find('.js-header-lang__item'),
        $langValue = $langWrap.find('.js-header-lang__value')
    
    $langWrap.on('click', function () {
        $langDropdown.fadeToggle()
    })
    
    $langItem.on('click', function () {
        let lang = $(this).find('span').text();
    
        $langValue.html(lang)
    })
    
    //fixed header 
    //mini header
    function fixedHeader() {
        if ($W.scrollTop() > 50) {
            $header.addClass("is-fixed");
        }
        else {
            $header.removeClass("is-fixed");
        }
    }
    fixedHeader();
    $W.scroll(function () {
        fixedHeader();
    });
    
    $('.js-scrollto').on('click', function () {
        $headerMobile.removeClass('is-active')
        $burger.removeClass('is-active')
    })
    
    	//header memu scroll to
	    const sections = document.querySelectorAll(".js-scroll-section");

	    window.addEventListener("scroll", navHighlighter);

	    function navHighlighter() {
		let scrollY = window.pageYOffset;

		sections.forEach(current => {
			const sectionHeight = current.offsetHeight;
			const sectionTop = current.getBoundingClientRect().top + window.pageYOffset - 60
			let sectionId = current.getAttribute("id");

			if ( sectionTop <= scrollY && sectionTop + sectionHeight > scrollY ) {
				document.querySelector(`.js-scrollto[href*= ${sectionId} ]`).classList.add("is-active");
			} else {
				document.querySelector(`.js-scrollto[href*= ${sectionId} ]`).classList.remove("is-active");
			}
		});
	}
    
    });

    $('.js-scroll-to-reg').on('click', function(){
        $('.js-header-mobile').removeClass('is-active');
        $('.js-burger').removeClass('is-active')
    })

 